module.exports = __webpack_public_path__ + "img/aA.37c9b9b5.svg";